import React, { Component } from "react";
import { compose } from "recompose";
import {
  Paper,
  withStyles,
  InputAdornment,
  Grid,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from "@material-ui/core";
import TextField from "@mui/material/TextField";
import FormatadorNumericoCustomizado from "features/manejo/views/components/FormatadorNumericoCustomizado";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { enviaDadosGAPorRotulo } from "../../../../../../shared/utils.js";
import { verificaToggleCreep } from "../../Farol/FarolUtils";
import { montaEstadoCocho } from "./cadastroUtils";
import SelectDropdown from "components/SelectDropdown/index.jsx";
import { t } from "adapters/i18n";

export class FormTrough extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Cocho: montaEstadoCocho(props.Cocho),
      CochoCreep: montaEstadoCocho(props.CochoCreep),
      FormCochoCreep: props.CochoCreep,
      expanded: props.CochoCreep,
    };
  }

  Coberto = [
    {
      emptyKey: true,
      value: "",
      disabled: true,
      label: t("common:commands.select"),
    },
    {
      value: true,
      label: t("pasture:covered"),
    },
    {
      value: false,
      label: t("pasture:uncovered"),
    },
  ];

  Elevado = [
    {
      emptyKey: true,
      value: "",
      disabled: true,
      label: t("common:commands.select"),
    },
    {
      value: true,
      label: t("common:actions.yes"),
    },
    {
      value: false,
      label: t("common:actions.no"),
    },
  ];

  EstoqueFinal = [
    {
      emptyKey: true,
      value: "",
      disabled: true,
      label: t("common:commands.select"),
    },
    {
      value: true,
      label: t("common:actions.yes"),
    },
    {
      value: false,
      label: t("common:actions.no"),
    },
  ];

  componentDidMount = () => {
    this.enviaDadosAnaliseGA();
  };

  enviaDadosAnaliseGA = () => {
    const acao = "Cadastrar pasto";
    let rotulo = "Acesso à aba avançado";
    const categoria = "Mapa";
    enviaDadosGAPorRotulo(acao, rotulo, categoria);
  };

  onChangeCochoTipo = (value) => {
    const event = {
      target: {
        value,
      },
    };
    this.props.handleChangeFormCocho("Coberto", event);
  };

  onChangeCochoElevado = (value) => {
    const event = {
      target: {
        value,
      },
    };
    this.props.handleChangeFormCocho("Elevado", event);
  };

  onChangeCochoEstoqueFinal = (value) => {
    const event = {
      target: {
        value,
      },
    };
    this.props.handleChangeFormCocho("EstoqueFinal", event);
  };

  onChangeCochoCreepTipo = (value) => {
    const event = {
      target: {
        value,
      },
    };

    this.props.handleChangeFormCochoCreep("Coberto", event);
  };

  onChangeCochoCreepElevado = (value) => {
    const event = {
      target: {
        value,
      },
    };
    this.props.handleChangeFormCochoCreep("Elevado", event);
  };

  onChangeCochoCreepEstoqueFinal = (value) => {
    const event = {
      target: {
        value,
      },
    };
    this.props.handleChangeFormCochoCreep("EstoqueFinal", event);
  };

  render() {
    const { classes, Toggles, Cocho, CochoCreep } = this.props;
    const { expanded } = this.state;
    const erros = this.props.errosValidacao.Cocho;
    let cadastroCompleto = false;
    const cochoForm = montaEstadoCocho(Cocho);
    const cochoCreepForm = montaEstadoCocho(CochoCreep);

    ["Coberto", "Elevado", "EstoqueFinal"].forEach((el) => {
      const value = cochoForm[el];
      cadastroCompleto =
        cadastroCompleto &&
        value !== "" &&
        value !== null &&
        value !== undefined;
    });

    const SharedTroughWarning = () => (
      <Grid container>
        <Typography variant={"body1"} align={"left"}>
          {t("pasture:shared-trough-message")}
        </Typography>
        <Typography variant={"subtitle2"} align={"left"}>
          {t("pasture:shared-trough-instructions")}
        </Typography>
      </Grid>
    );

    return (
      <>
        {cochoForm.CochoCompartilhado ? (
          <SharedTroughWarning />
        ) : (
          <form noValidate autoComplete="off" onSubmit={this.handleSubmit}>
            <Grid id="formCochoComponent">
              <Grid item xs={12} className={classes.defaultTroughForm}>
                <Paper className={classes.paper}>
                  <div className={classes.formContainer}>
                    <SelectDropdown
                      testId="cocho-coberto"
                      label={{ text: t("pasture:trough-type") }}
                      error={!!erros.Coberto}
                      options={this.Coberto}
                      value={cochoForm.Coberto}
                      onChange={this.onChangeCochoTipo}
                    />
                    <TextField
                      id="comprimento"
                      variant="outlined"
                      className={classes.textField}
                      error={!!erros.Comprimento}
                      helperText={erros.Comprimento}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: FormatadorNumericoCustomizado,
                        endAdornment: (
                          <InputAdornment position="end">cm</InputAdornment>
                        ),
                      }}
                      label={t("pasture:length")}
                      onChange={(event) =>
                        this.props.handleChangeFormCocho("Comprimento", event)
                      }
                      value={cochoForm.Comprimento ? cochoForm.Comprimento : ""}
                    />
                    <SelectDropdown
                      id="cocho-elevado"
                      label={{ text: t("pasture:elevated") }}
                      options={this.Elevado}
                      value={cochoForm.Elevado}
                      error={!!erros.Elevado}
                      helperText={erros.Elevado}
                      onChange={this.onChangeCochoElevado}
                    />
                    <SelectDropdown
                      id="cocho-estoque-final"
                      label={{ text: t("pasture:final-stock") }}
                      options={this.EstoqueFinal}
                      value={cochoForm.EstoqueFinal}
                      error={!!erros.EstoqueFinal}
                      helperText={erros.EstoqueFinal}
                      onChange={this.onChangeCochoEstoqueFinal}
                    />
                  </div>
                </Paper>
              </Grid>

              {verificaToggleCreep(Toggles) && (
                <Grid item xs={12} className={classes.expansionPanelContainer}>
                  <ExpansionPanel
                    classes={{ root: classes.paper }}
                    id="formCochoCreepComponent"
                    expanded={expanded}
                  >
                    <ExpansionPanelSummary
                      id="expansionPanelSummary"
                      classes={{
                        root: classes.expansionPanelSummary,
                        expandIcon: classes.expandIcon,
                        expanded: classes.expansionPanelSummaryExpanded,
                      }}
                      expandIcon={<ExpandMoreIcon />}
                      onClick={() =>
                        this.setState({
                          expanded: !expanded,
                          FormCochoCreep: !this.state.FormCochoCreep,
                        })
                      }
                    >
                      <Typography
                        variant="subtitle2"
                        className={classes.subtitle}
                      >
                        {t("pasture:add-creep-feeder")}
                      </Typography>
                    </ExpansionPanelSummary>

                    <ExpansionPanelDetails
                      className={classes.expansionPanelDetails}
                    >
                      <div className={classes.formContainer}>
                        <SelectDropdown
                          id="cocho-coberto-creep"
                          label={{ text: t("pasture:trough-type") }}
                          options={this.Coberto}
                          value={cochoCreepForm.Coberto}
                          error={!!erros.Coberto}
                          helperText={erros.Coberto}
                          onChange={this.onChangeCochoCreepTipo}
                        />
                        <TextField
                          id="comprimento-creep"
                          className={classes.textField}
                          error={!!erros.Comprimento}
                          helperText={erros.Comprimento}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            inputComponent: FormatadorNumericoCustomizado,
                            endAdornment: (
                              <InputAdornment position="end">cm</InputAdornment>
                            ),
                          }}
                          label={t("pasture:length")}
                          onChange={(event) =>
                            this.props.handleChangeFormCochoCreep(
                              "Comprimento",
                              event
                            )
                          }
                          value={
                            cochoCreepForm.Comprimento
                              ? cochoCreepForm.Comprimento
                              : ""
                          }
                        />
                        <SelectDropdown
                          id="cocho-elevado-creep"
                          label={{ text: t("pasture:elevated") }}
                          options={this.Elevado}
                          value={cochoCreepForm.Elevado}
                          error={!!erros.Elevado}
                          helperText={erros.Elevado}
                          onChange={this.onChangeCochoCreepElevado}
                        />
                        <SelectDropdown
                          id="cocho-estoque-final-creep"
                          label={{ text: t("pasture:final-stock") }}
                          options={this.EstoqueFinal}
                          value={cochoCreepForm.EstoqueFinal}
                          error={!!erros.EstoqueFinal}
                          helperText={erros.EstoqueFinal}
                          onChange={this.onChangeCochoCreepEstoqueFinal}
                        />
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              )}
            </Grid>
          </form>
        )}
      </>
    );
  }
}

FormTrough.propTypes = {
  Cocho: PropTypes.object,
  CochoCreep: PropTypes.object,
  errosValidacao: PropTypes.object,
  handleChangeFormCocho: PropTypes.func.isRequired,
  handleChangeFormCochoCreep: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

FormTrough.defaultProps = {
  errosValidacao: {
    Coberto: "",
    Comprimento: "",
    Elevado: "",
    EstoqueFinal: "",
  },
};

const styles = (theme) => ({
  defaultTroughForm: {
    marginTop: 16,
  },
  paper: {
    padding: 16,
    borderRadius: "4px !important",
  },
  expansionPanelContainer: {
    marginTop: 40,
  },
  expansionPanelSummary: {
    padding: "0 !important",
    margin: "0 !important",
    minHeight: "0 !important",
  },
  expansionPanelSummaryExpanded: {
    padding: "0 !important",
    margin: "0 !important",
    minHeight: "0 !important",
  },
  expandIcon: {
    rigth: 0,
    padding: 0,
  },
  expansionPanelDetails: {
    padding: 0,
    marginTop: 32,
  },
  subtitle: {
    fontSize: "16px",
    fontFamily: "Roboto",
    letterSpacing: "normal",
  },
  textField: {
    width: "100%",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",

    width: "100%",
  },
});

export default compose(withStyles(styles))(FormTrough);
